<template>
  <div class="history" @click="showExist = false">
    <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/results'})">返回</i>

    <div class="history_wrap">
      <div class="history_box">
        <p class="history_title">检测结果</p>
        <p class="tips">{{ date | dateFormat}},您血液神经酰胺CER检测结果及心血管疾病风险评估结果为：</p>
        <van-grid :column-num="3">
          <van-grid-item>代谢物名称</van-grid-item>
          <van-grid-item>检测结果</van-grid-item>
          <van-grid-item>参考值</van-grid-item>
        </van-grid>
        <van-grid :column-num="3" v-for="(item, index) in houseResult" :key="index">
          <van-grid-item>{{ item.name }}</van-grid-item>
          <van-grid-item :class="{ red: item.higher }">{{ item.value }}</van-grid-item>
          <van-grid-item>{{ item.reference }}</van-grid-item>
        </van-grid>
        <div class="risk">
          <p class="risk_title">{{ timeSpan }}年内发病风险约为：</p>
          <div class="risk_num">{{ risk | fixed(2)}}%</div>
        </div>
        <div class="risk risk_multiple">
          <p class="risk_title">与同龄人相比您的发病风险倍数：</p>
          <div class="risk_multiple_img">
            <img :style="{ left: riskMultiple / maxRiskMultiple * 100 + '%' }" src="../../assets/images/ceramide/heart.png" alt="心脏">
            <div class="risk_gradient">
              <i class="vertical_line" :style="{ left: riskMultiple / maxRiskMultiple * 100 + '%' }"></i>
            </div>
            <p class="min">{{ minRiskMultiple | fixed(1) }}</p>
            <p class="multiple" :style="{ left: riskMultiple / maxRiskMultiple * 100 + '%' }">{{ riskMultiple }}倍</p>
            <p class="max">{{ maxRiskMultiple | fixed(1) }}</p>
          </div>
          <div class="riskLevel">
            <p class="risk_title">您的发病风险等级：</p>
            <van-collapse v-model="activeNames">
              <van-collapse-item name="1">
                <template #title>
                  <p class="rlevel" :class="{high: riskLevel === '高等风险', higher: riskLevel === '较高风险', general: riskLevel === '中等风险', low: riskLevel === '低等风险'}">
                    {{ riskLevel }}
                  </p>
                </template>
                <p>风险等级分为：低等风险，中等风险，较高风险，高等风险。</p>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
      <div class="health_advice">
        <div class="history_box">
          <p class="history_title">健康管理建议</p>
          <div class="advice_tab">
            <p :class="{ active: active === 0 }" @click="active = 0">健管建议</p>
            <p :class="{ active: active === 1 }" @click="active = 1">报告解读</p>
          </div>
          <div class="advice_item" v-show="active === 0">
            {{ healthAdvice }}
          </div>
          <div class="advice_item" v-show="active === 1">
            {{ reportInterpertation }}
          </div>
          <div class="advice_btn" @click="$router.push({path: '/riskFactors'})">
            <p>查看心血管危险因素</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'historyInfo',
  data () {
    return {
      active: 0,
      activeNames: ['0'],
      houseResult: [],
      timeSpan: 1,
      risk: 1,
      riskMultiple: 1,
      healthAdvice: '',
      reportInterpertation: '',
      scode: this.$route.params.scode,
      date: this.$route.params.date,
      minRiskMultiple: '',
      maxRiskMultiple: '',
      riskLevel: ''
    }
  },
  methods: {
    result () {
      let data = {
        scode: this.scode
      }
      this.util.get(this.api.result, data, (success) => {
        this.timeSpan = success.data.timeSpan
        this.risk = success.data.risk
        this.riskMultiple = success.data.riskMultiple
        this.healthAdvice = success.data.healthAdvice
        this.reportInterpertation = success.data.reportInterpretation
        this.houseResult = success.data.houseResult
        this.minRiskMultiple = success.data.minRiskMultiple
        this.maxRiskMultiple = success.data.maxRiskMultiple
        this.riskLevel = success.data.riskLevel
        for (let i in this.houseResult) {
          this.houseResult[i].name = i
          switch (i) {
            case 'cer-1':
              this.houseResult[i].reference = '0.19–0.36 mcmol/L'
              break
            case 'cer-2':
              this.houseResult[i].reference = '0.05–0.14 mcmol/L'
              break
            case 'cer-3':
              this.houseResult[i].reference = '0.65–1.65 mcmol/L'
              break
            case 'cer-1/cer-4':
              this.houseResult[i].reference = '<0.11'
              break
            case 'cer-2/cer-4':
              this.houseResult[i].reference = '<0.05'
              break
            case 'cer-3/cer-4':
              this.houseResult[i].reference = '<0.45'
              break
          }
        }
      })
    }
  },
  mounted () {
    this.result()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .history {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .bars {
      position: absolute;
      top: pxToRem(20px);
      right: pxToRem(30px);
    }

    .high {
      color: #e3542b;
    }

    .higher {
      color: #f3ac3c;
    }

    .general {
      color: #80ba41;
    }

    .low {
      color: #71c2de;
    }

    .history_wrap {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .history_box {
        padding: pxToRem(80px);
        background: #fff;
        border-radius: pxToRem(20px);

        .history_title {
          font-size: pxToRem(36px);
          font-weight: bold;
          color: #2A6BAE;
          text-align: center;
          margin-bottom: pxToRem(53px);
        }

        .tips {
          margin-bottom: pxToRem(40px);
        }

        .risk {
          margin-top: pxToRem(68px);

          .risk_title {
            font-size: pxToRem(22px);
            font-weight: bold;
            color: #000;
          }

          .risk_num {
            width: pxToRem(90px);
            height: pxToRem(90px);
            line-height: pxToRem(90px);
            font-size: pxToRem(18px);
            text-align: center;
            color: #fff;
            background: url('../../assets/images/ceramide/riskBg.png') no-repeat center;
            background-size: cover;
            border-radius: 50%;
            margin: pxToRem(10px) auto 0;
          }
        }

        .risk_multiple {
          margin-top: pxToRem(30px);

          .risk_multiple_img {
            position: relative;
            margin-top: pxToRem(20px);
            padding-bottom: pxToRem(180px);

            img {
              position: absolute;
              top: 0;
              left: 0;
              width: pxToRem(70px);
              height: pxToRem(40px);
              margin-left: pxToRem(-35px);
            }

            .risk_gradient {
              width: 100%;
              height: pxToRem(38px);
              border-radius: pxToRem(10px);
              background: url('../../assets/images/ceramide/gradient.png') no-repeat center;
              background-size: cover;
              position: absolute;
              top: pxToRem(50px);
              left: 0;

              .vertical_line {
                width: pxToRem(37px);
                height: pxToRem(38px);
                border-right: 1px solid #fff;
                position: absolute;
                margin-left: pxToRem(-38px);
                left: 0;
              }
            }

            .min, .max {
              position: absolute;
              font-size: pxToRem(19px);
              bottom: 0;
            }

            .max {
              right: 0;
            }

            .multiple {
              font-size: pxToRem(19px);
              text-align: center;
              width: pxToRem(70px);
              margin-left: pxToRem(-35px);
              position: absolute;
              top: pxToRem(100px);
            }
          }

          .riskLevel {
            margin-top: pxToRem(30px);

            .rlevel {
              font-size: pxToRem(32px);
              font-weight: bold;
              text-align: center;
              margin-top: pxToRem(10px);
            }
          }
        }
      }

      .health_advice {
        margin-top: pxToRem(50px);

        .pk {
          font-size: pxToRem(22px);
          font-weight: 300;
          text-align: right;
          margin-bottom: pxToRem(28px);

          .arrow {
            margin-left: pxToRem(10px);
            vertical-align: middle;
          }
        }

        .advice_tab {
          display: flex;
          justify-content: space-around;
          align-items: center;
          p {
            width: pxToRem(254px);
            height: pxToRem(64px);
            line-height: pxToRem(64px);
            text-align: center;
            font-size: pxToRem(20px);
            font-weight: 300;
            color: #7aa7d1;
            letter-spacing: 1px;
            background: #2a68b1;
          }
          .active {
            background: #469fe3;
            color: #fff;
          }
        }

        .advice_item {
          font-size: pxToRem(22px);
          text-indent: 2em;
          padding: pxToRem(80px) pxToRem(27px);
          text-align: justify;
        }

        .advice_btn {
          text-align: center;
          margin-top: pxToRem(40px);

          p {
            display: inline-block;
            background: url('../../assets/images/ceramide/healthbtn.png') no-repeat center;
            background-size: 100% 100%;
            font-size: pxToRem(28px);
            color: #fff;
            text-align: center;
            padding: pxToRem(12px) pxToRem(50px)  pxToRem(16px);
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .history {
    .van-grid {
      flex-wrap: nowrap;
    }
    .van-grid:nth-of-type(even) .van-grid-item__content {
      background: #fff;
    }
    .van-grid:nth-of-type(odd) .van-grid-item__content {
      background: #E3F2FF;
    }
    .van-grid:nth-of-type(1) .van-grid-item__content {
      background: #C4E3FE;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/ceramide/historyInfo.vue